import { current, isDraft, WritableDraft } from "immer";
import { FilterV2Event } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_events";
import { FiltersV2StoreType } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";

const snapshot = <T>(value: T): T => (isDraft(value) ? (current(value) as T) : value);

export const emitFiltersMetaSynced = (draftState: WritableDraft<FiltersV2StoreType>) => {
  draftState.eventsBus.emit(FilterV2Event.FiltersMetaSynced, {
    mainFilters: snapshot(draftState.mainFilters),
    childrenFilters: snapshot(draftState.childrenFilters),
    areChildrenOn: draftState.areChildrenOn
  });
};
